function getInitialMenuCueState(menuList) {

  const menuCueState = {};

  const menuListLength = menuList.length;

  for (let index = 0; index < menuListLength; index++) {

    const menuItem = menuList[index];

    menuCueState[menuItem.name] = false;

  }

  return menuCueState;

}

export {
  getInitialMenuCueState
};